<template>
  <div class="calculator">
    <div class="input">
      <div class="item">
        <label>月利润 (&yen;):</label>
        <input v-model="profit" @focus="selectAll" type="tel" placeholder="20000">
      </div>
      <div class="item" v-for="(value, index) in volumes" :key="index">
        <label>销量 ({{ index }}) (件):</label>
        <span>
          <template v-if="index === 0">
            <button @click="appendVolume()">+</button>
          </template>
          <template v-else>
            <button @click="removeVolume(index)">-</button>
          </template>
          <input v-model="volumes[index]" @focus="selectAll" type="tel" placeholder="0">
        </span>
      </div>
    </div>
    <div class="item">
      <span>基本底薪:</span>
      <span class="value">{{ salary.BASE | money }}</span>
    </div>
    <div class="item">
      <span>底薪加成:</span>
      <span class="value plus">{{ salary.baseAddition | money }}</span>
    </div>
    <div class="item">
      <span>提成:</span>
      <span class="value plus">{{ salary.commission | money }}</span>
    </div>
    <div class="item">
      <span>提成奖励:</span>
      <span class="value plus">{{ salary.commissionBonus | money }}</span>
    </div>
    <div class="item">
      <span>销量奖励:</span>
      <span class="value plus">{{ salary.saleVolumesBonus | money }}</span>
    </div>
    <div class="item amount">
      <span>月总收益:</span>
      <span class="value">{{ salary.monthly | money }}</span>
    </div>
    <div class="item">
      <span>预期年利润:</span>
      <span class="value">{{ profit * 12 | money }}</span>
    </div>
    <div class="item">
      <span>预期年终奖:</span>
      <span class="value">{{ salary.yearEndBonus | money }}</span>
    </div>
    <div class="item amount">
      <span>预期年总收益:</span>
      <span class="value">{{ salary.yearly | money }}</span>
    </div>
  </div>
</template>

<script>
import formula from "../common/formula";

export default {
  data() {
    return {
      profit: 0,
      volumes: [0]
    };
  },
  computed: {
    salary() {
      return formula(
        Number(this.$data.profit),
        this.$data.volumes.map(Number).filter(Boolean)
      );
    }
  },
  filters: {
    money: v => v.toFixed(2)
  },
  methods: {
    appendVolume() {
      this.$data.volumes.push(0);
    },
    removeVolume(index) {
      this.$data.volumes.splice(index, 1);
    },
    selectAll(e) {
      let element = e.currentTarget
      if (!element) {
        return
      }
      element.setSelectionRange(0, element.value.length)
    },
  }
};
</script>

<style lang="postcss" scoped>
.calculator {
  margin: 0 auto 96px;
  width: 100%;
  max-width: 480px;
  padding: 0 16px;
  box-sizing: border-box;
  .input {
    margin-bottom: 1em;
    border-bottom: 1px solid hsl(200, 1%, 95%);
  }
  .item {
    margin: 12px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    color: hsl(200, 1%, 30%);
    button {
      display: inline-block;
      margin: 0 1em 0 0;
      padding: 2px 8px;
      border-radius: 4px;
      border: 1px solid hsl(200, 1%, 85%);
      background-color: transparent;
    }
    input {
      width: 80px;
      text-align: right;
      font-size: 15px;
      padding: 2px 4px;
      border-radius: 4px;
      border: 1px solid hsl(200, 1%, 85%);
      box-shadow: none;
      background-color: #fff;
    }
    .value {
      &:before {
        content: "\00A5";
        padding-right: 0.25em;
      }
      &.plus {
        color: hsl(140, 60%, 45%);
        &:before {
          content: "+";
        }
      }
    }
    &.amount {
      margin: 1em 0;
      padding: 1em 0;
      border-top: 1px solid hsl(200, 1%, 95%);
      color: hsl(200, 1%, 10%);
    }
  }
}
</style>
